import { Box, IconButton, Stack, alpha } from "@mui/material";
import React from "react";
import ImageUploading from "react-images-uploading";
import { HelperText } from "../elements/HelperText";
import { InboxOutlined } from "@ant-design/icons";
import { primaryColor } from "../../theme/Theme";
import { Close } from "@mui/icons-material";
import { formatFileSize } from "../../utils/helpers";

export default function ImageUploader({ images, setImages, limit, size }) {
  const maxNumber = limit || 3;
  size = size * 1000000; // size delimiter (apply by MB standard)
  const maxSize = size || 300000; // 300KB
  const onChange = (imageList) => {
    // data for submit
    setImages(imageList);
  };

  return (
    <div>
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxFileSize={maxSize}
        maxNumber={maxNumber}
        dataURLKey="data_url"
        // acceptType={["jpg"]}
      >
        {({ imageList, onImageUpload, onImageRemove, dragProps }) => (
          // write your building UI
          <div>
            <Stack
              spacing={1}
              mb={1}
              onClick={onImageUpload}
              {...dragProps}
              sx={{
                p: 2,
                border: "1px dashed #ccc",
                borderRadius: 2,
                background: "#f9f9f9",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 200ms ease-in-out",
                "&:hover": {
                  borderColor: alpha(primaryColor, 0.8),
                },
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined style={{ fontSize: 45, color: primaryColor }} />
              </p>
              <p>Click or drag to upload</p>
              <HelperText
                centered
                text={`Drop your images here, or select click to browse. Max file size (${formatFileSize(
                  maxSize
                )})`}
              />
            </Stack>

            {/* Image View */}
            {images?.length > 0 && (
              <Stack direction="row" spacing={2} mb={1} mt={2}>
                {imageList.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      border: "1px dashed #ccc",
                      borderRadius: 2,
                      height: 80,
                      width: 80,
                      p: 1,
                      maxHeight: { xs: 233, md: 167 },
                      position: "relative",
                      bgcolor: "#f2f2f2",
                      transition: "all 200ms ease-in-out",
                      "&:hover": {
                        filter: "brightness(90%)",
                        color: "red",
                      },
                    }}
                  >
                    <img
                      src={image.data_url}
                      alt={image.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 6,
                      }}
                    />
                    <IconButton
                      color="inherit"
                      sx={{ position: "absolute", top: 0, right: 0 }}
                      // size="small"
                      onClick={() => onImageRemove(index)}
                    >
                      <Close fontSize="small" color="inherit" />
                    </IconButton>
                  </Box>
                ))}
              </Stack>
            )}
          </div>
        )}
      </ImageUploading>
    </div>
  );
}
